import appStore from "store";
import api from "./api";

const store = {
  namespaced: true,
  state: {
    tableList: [],
    totalCount: 0,
    pairList: []
  },

  mutations: {
    setTabList(state, payload) {
      state.tableList = payload;
    },
    setTotalCount(state, payload) {
      state.totalCount = payload
    },
    setPairList(state, payload) {
      state.pairList = payload
    }
  },
  actions: {
    async getlist({ commit }, params) {
      const res = await api.getRobotList(params)
      commit("setTabList", res.data.items);
      commit('setTotalCount', res.data.total)
      return res
    },
  },
};

appStore.registerModule("robotSotre", store);
